export enum ContactBalanceType {
  Creditor = 'creditor',
  Debtor = 'debtor',
}
